import type { ExportJobStatusType } from "@/constant/export/ExportJobStatus";
import {
  createEntityAdapter,
  createSlice,
  type PayloadAction,
} from "@reduxjs/toolkit";

interface FileDownload {
  fileName: string;
  jobId: string;
  status: ExportJobStatusType;
  errorMessage: any;
  url: string;
  date: string;
}

interface ProgressUpdate {
  jobId: string;
  progressPercent: number;
}

const list = createEntityAdapter<FileDownload, string>({
  // @ts-ignore
  selectId: (file: FileDownload) => file.jobId,
});

const progressUpdate = createEntityAdapter<ProgressUpdate, string>({
  //@ts-ignore
  selectId: (progress: ProgressUpdate) => progress.jobId,
});

const initialListState = list.getInitialState();
const initialProgressState = progressUpdate.getInitialState();

export const fileDownloadSlice = createSlice({
  name: "fileDownload",
  initialState: {
    list: initialListState,
    progressUpdate: initialProgressState,
    showExportPopover: false,
  },
  reducers: {
    setShowExportPopover: (state, action: PayloadAction<boolean>) => {
      state.showExportPopover = action.payload;
    },
    addFileToDownload: (state, action: PayloadAction<FileDownload>) => {
      list.addOne(state.list, action.payload);
      progressUpdate.addOne(state.progressUpdate, {
        jobId: action.payload.jobId,
        progressPercent: 0,
      });
    },
    removeFileFromDownload: (state, action: PayloadAction<string>) => {
      list.removeOne(state.list, action.payload);
    },
    updateFileDataInDownload: (
      state,
      action: PayloadAction<Partial<FileDownload>>
    ) => {
      if (action.payload.jobId) {
        list.updateOne(state.list, {
          id: action.payload.jobId,
          changes: {
            ...(state.list.entities[action.payload?.jobId] || {}),
            ...action.payload,
          },
        });
        progressUpdate.removeOne(state.progressUpdate, action?.payload.jobId);
      }
    },
    updateFileProgressInDownload: (
      state,
      action: PayloadAction<{
        jobId: string;
        progressPercent: number;
      }>
    ) => {
      if (state.progressUpdate?.ids?.includes(action?.payload?.jobId)) {
        progressUpdate.updateOne(state.progressUpdate, {
          id: action.payload?.jobId,
          changes: action.payload,
        });
      } else {
        progressUpdate.addOne(state.progressUpdate, action.payload);
      }
    },
  },
});

export const {
  addFileToDownload,
  removeFileFromDownload,
  updateFileDataInDownload,
  updateFileProgressInDownload,
  setShowExportPopover,
} = fileDownloadSlice.actions;

export default fileDownloadSlice.reducer;
